import { useEffect, useState, useCallback } from 'react';

import { useDispatch, useSelector } from '_common/hooks';
import { listObjects } from '_common/components/Table/TableSlice';
import { setCurrentAppPage } from 'App/redux/appSlice';
import { toggleInfoPanel } from 'Storage/pages/SpacesListPage/redux/spacesListPageSlice';
import { setActiveTab, setTriggerPage } from 'Search/redux/SearchPageSlice';

import { InformationPanel, InteractionController, IntlErrorBoundary } from '_common/components';
import Header from './Header';
import Table from './Table/Table';

import styles from './SpacesListPage.module.scss';

import type { paths } from '_types/api';
import { InstanceService } from '_common/services';

export const PAGE_IDENTITY = 'spaces';

/**
 * Spaces Page
 */
const SpacesListPage = () => {
  const dispatch = useDispatch();

  const infoPanelOpen = useSelector((state) => state.spaces.infoPanelOpen);

  const fetchObjects = useCallback(async (parameters: any) => {
    const res = await new InstanceService().listSpaces(parameters);
    setPermissions(res.data.permissions);
    return res;
  }, []);

  const [permissions, setPermissions] =
    useState<
      paths['/api/object/space/list']['get']['responses']['200']['content']['application/json']['permissions']
    >();

  useEffect(() => {
    dispatch(setCurrentAppPage('/storage/spaces'));
    dispatch(setTriggerPage('spaces'));
    dispatch(setActiveTab('spaces'));
    dispatch(
      listObjects({
        identity: PAGE_IDENTITY,
        fetch: fetchObjects,
        cause: 'INITIAL',
        request: { offset: 0 },
      }),
    );
  }, []);

  const handleCloseInfoPanel = () => {
    dispatch(toggleInfoPanel());
  };

  const renderContentView = () => {
    // TODO: render content loading state
    return (
      <div className={styles.content}>
        <div className={styles.tableWrapper}>
          <InteractionController
            environment="explorer"
            rules={[{ interaction: 'explorer_spaces_space_click' }]}
            style={{ width: '100%', height: '100%' }}
          >
            <Table fetchObjects={fetchObjects} />
          </InteractionController>
        </div>

        <InformationPanel
          isOpen={infoPanelOpen}
          onClose={handleCloseInfoPanel}
          testId="spaces-information-panel"
        />
      </div>
    );
  };

  return (
    <div className={styles.root} data-testid="spaces-root">
      <div className={styles.header}>
        <IntlErrorBoundary size="s" style={{ margin: '0 0 0 7rem' }}>
          <Header permissions={permissions} />
        </IntlErrorBoundary>
      </div>

      {renderContentView()}
    </div>
  );
};

export default SpacesListPage;
